module.exports = __webpack_public_path__ + "static/media/amrita.83d0b35d.png";